"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bodyScrollLock = require("body-scroll-lock");

var _scss = require("@scss");

var _Collapse = _interopRequireDefault(require("@components/Collapse"));

var _Image = _interopRequireDefault(require("@components/Images/Image"));

var _Link = _interopRequireDefault(require("Link"));

var _Navigation = _interopRequireDefault(require("@components/Navigation"));

var _Icon = _interopRequireDefault(require("@components/Icon"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["kind", "logo", "sticky", "hideOnScroll", "navs", "hamburgerIcon", "dropdownIcon", "children", "preNavContent", "postNavContent", "footerMobile", "classes", "megaMenu", "customMegaMenu", "customNavMobile", "forceCollapseStyle", "onMenuToggle", "closeOnClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function HeaderLogoChildren(_ref) {
  var src = _ref.src,
      link = _ref.link,
      width = _ref.width,
      height = _ref.height;
  return typeof src === 'string' ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    className: "d-block",
    "data-default": true,
    src: src,
    alt: link !== null && link !== void 0 && link.title ? link.title : 'Logo',
    height: height,
    width: width
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Object.keys(src).map(function (name) {
    return /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      key: name,
      className: "d-block",
      "data-name": name,
      src: src[name],
      alt: link !== null && link !== void 0 && link.title ? link.title : 'Logo',
      height: height,
      width: width
    });
  }));
}

function HeaderLogo(props) {
  var _props$classes, _props$classes2;

  return props.link ? /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({}, props.link, {
    classes: {
      root: (_props$classes = props.classes) === null || _props$classes === void 0 ? void 0 : _props$classes.wrapper
    }
  }), /*#__PURE__*/_react["default"].createElement(HeaderLogoChildren, props)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)((_props$classes2 = props.classes) === null || _props$classes2 === void 0 ? void 0 : _props$classes2.wrapper)
  }, /*#__PURE__*/_react["default"].createElement(HeaderLogoChildren, props));
}

function HamburgerIcon(props) {
  var _props$classes3, _props$classes4, _props$classes5;

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    "aria-label": "Menu",
    "data-hamburger": true
  }, props.onClick && {
    onClick: props.onClick
  }, {
    className: (0, _scss.cls)(_stylesModule["default"]['hamburger-icon'], props === null || props === void 0 ? void 0 : (_props$classes3 = props.classes) === null || _props$classes3 === void 0 ? void 0 : _props$classes3.wrapper)
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    classes: {
      icon: (0, _scss.cls)(_stylesModule["default"].icon, _stylesModule["default"]['icon-default'], props === null || props === void 0 ? void 0 : (_props$classes4 = props.classes) === null || _props$classes4 === void 0 ? void 0 : _props$classes4.icon)
    },
    name: (props === null || props === void 0 ? void 0 : props["default"]) || 'hamburger-default',
    alt: "Open menu"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    classes: {
      icon: (0, _scss.cls)(_stylesModule["default"].icon, _stylesModule["default"]['icon-close'], props === null || props === void 0 ? void 0 : (_props$classes5 = props.classes) === null || _props$classes5 === void 0 ? void 0 : _props$classes5.icon)
    },
    name: (props === null || props === void 0 ? void 0 : props.close) || 'hamburger-close',
    alt: "Close menu"
  }));
}

var Header = /*#__PURE__*/(0, _react.forwardRef)(function Header(_ref2, ref) {
  var _logo$classes;

  var _ref2$kind = _ref2.kind,
      kind = _ref2$kind === void 0 ? 'default' : _ref2$kind,
      logo = _ref2.logo,
      sticky = _ref2.sticky,
      hideOnScroll = _ref2.hideOnScroll,
      navs = _ref2.navs,
      hamburgerIcon = _ref2.hamburgerIcon,
      dropdownIcon = _ref2.dropdownIcon,
      children = _ref2.children,
      preNavContent = _ref2.preNavContent,
      postNavContent = _ref2.postNavContent,
      footerMobile = _ref2.footerMobile,
      classes = _ref2.classes,
      megaMenu = _ref2.megaMenu,
      customMegaMenu = _ref2.customMegaMenu,
      customNavMobile = _ref2.customNavMobile,
      forceCollapseStyle = _ref2.forceCollapseStyle,
      onMenuToggle = _ref2.onMenuToggle,
      _ref2$closeOnClick = _ref2.closeOnClick,
      closeOnClick = _ref2$closeOnClick === void 0 ? false : _ref2$closeOnClick,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      megaMenuItems = _useState4[0],
      setMegaMenuItems = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      megaMenuChildren = _useState6[0],
      setMegaMenuChildren = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      megaMenuProps = _useState8[0],
      setMegaMenuProps = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showMegaMenu = _useState10[0],
      setShowMegaMenu = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isMobileMode = _useState12[0],
      setIsMobileMode = _useState12[1];

  var headerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined' || !(headerRef !== null && headerRef !== void 0 && headerRef.current)) {
      return;
    }

    var hamburgerDom = headerRef.current.querySelector('[data-hamburger]');

    if (!hamburgerDom) {
      return;
    }

    var onResize = function onResize() {
      setIsMobileMode(!!(hamburgerDom !== null && hamburgerDom !== void 0 && hamburgerDom.offsetParent));
    };

    onResize();
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [headerRef]);
  (0, _react.useEffect)(function () {
    if (!isMobileMode) {
      setMenuOpen(false);
    }
  }, [isMobileMode]);
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined' || !sticky) {
      return;
    }

    var lastScroll = 0;

    var onScroll = function onScroll() {
      window.document.body.dataset.scroll = window.scrollY < 10 ? 'none' : window.scrollY > lastScroll ? 'down' : 'up';
      lastScroll = window.scrollY;
    };

    window.addEventListener('scroll', onScroll);
    onScroll();
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [sticky]);
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined') return;

    if (showMegaMenu) {
      window.document.body.dataset.showMegaMenu = 'true';
    } else {
      window.document.body.dataset.showMegaMenu = 'false';
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [showMegaMenu]);
  (0, _react.useEffect)(function () {
    if (typeof window === 'undefined' || !(headerRef !== null && headerRef !== void 0 && headerRef.current)) return;
    var ref = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current;

    if (menuOpen) {
      window.document.body.dataset.menuOpen = 'true';
      (0, _bodyScrollLock.disableBodyScroll)(ref);
    } else {
      window.document.body.dataset.menuOpen = 'false';
      (0, _bodyScrollLock.enableBodyScroll)(ref);
    }

    return function () {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuOpen, headerRef === null || headerRef === void 0 ? void 0 : headerRef.current]);
  (0, _react.useEffect)(function () {
    if (!onMenuToggle) {
      return;
    }

    onMenuToggle(menuOpen);
  }, [menuOpen, onMenuToggle]);

  var _close = (0, _react.useCallback)(function () {
    return setMenuOpen(false);
  }, []);

  var _closeAll = (0, _react.useCallback)(function () {
    _close();

    setShowMegaMenu(false);
    setMegaMenuChildren(null);
  }, []);

  var open = (0, _react.useCallback)(function () {
    return setMenuOpen(true);
  }, []);

  var _toggle = (0, _react.useCallback)(function () {
    return setMenuOpen(function (prevValue) {
      return !prevValue;
    });
  }, []);

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      close: function close() {
        return _close();
      },
      closeAll: function closeAll() {
        return _closeAll();
      },
      open: function (_open) {
        function open() {
          return _open.apply(this, arguments);
        }

        open.toString = function () {
          return _open.toString();
        };

        return open;
      }(function () {
        return open();
      }),
      toggle: function toggle() {
        return _toggle();
      },
      menuOpen: menuOpen,
      showMegaMenu: showMegaMenu
    };
  }, [menuOpen, showMegaMenu, _close, _closeAll, open, _toggle]);
  var dropdownItemClasses = (0, _react.useMemo)(function () {
    return {
      dropdownWrapper: classes === null || classes === void 0 ? void 0 : classes.dropdownWrapper,
      dropdownListItem: (0, _scss.cls)(_stylesModule["default"]['dropdown-list-item'], classes === null || classes === void 0 ? void 0 : classes.dropdownListItem),
      dropdownItem: {
        root: (0, _scss.cls)(_stylesModule["default"]['dropdown-item'], classes === null || classes === void 0 ? void 0 : classes.dropdownItem),
        active: (0, _scss.cls)(_stylesModule["default"]['dropdown-item--active'], classes === null || classes === void 0 ? void 0 : classes.dropdownItemActive)
      }
    };
  }, [classes]);
  var megaMenuClasses = (0, _react.useMemo)(function () {
    return {
      wrapper: (0, _scss.cls)(_stylesModule["default"]['mega-menu-wrapper'], classes === null || classes === void 0 ? void 0 : classes.megaMenuWrapper),
      listItem: (0, _scss.cls)(_stylesModule["default"]['dropdown-list-item'], classes === null || classes === void 0 ? void 0 : classes.dropdownListItem),
      item: {
        root: (0, _scss.cls)(_stylesModule["default"]['dropdown-item'], classes === null || classes === void 0 ? void 0 : classes.dropdownItem),
        active: (0, _scss.cls)(_stylesModule["default"]['dropdown-item--active'], classes === null || classes === void 0 ? void 0 : classes.dropdownItemActive)
      },
      dropdownWrapper: classes === null || classes === void 0 ? void 0 : classes.dropdownWrapper
    };
  }, [classes]);
  var getNavigationClasses = (0, _react.useCallback)(function (nav) {
    var _nav$classes;

    return _objectSpread({
      wrapper: (0, _scss.cls)(_stylesModule["default"].navigation, _stylesModule["default"]["navigation-align-".concat(nav.align)], classes === null || classes === void 0 ? void 0 : classes.navigation, nav === null || nav === void 0 ? void 0 : (_nav$classes = nav.classes) === null || _nav$classes === void 0 ? void 0 : _nav$classes.wrapper),
      listItem: (0, _scss.cls)(_stylesModule["default"]['navigation-list-item'], classes === null || classes === void 0 ? void 0 : classes.navigationListItem),
      item: {
        root: (0, _scss.cls)(_stylesModule["default"]['navigation-item'], classes === null || classes === void 0 ? void 0 : classes.navigationItem),
        active: (0, _scss.cls)(_stylesModule["default"]['navigation-item--active'], classes === null || classes === void 0 ? void 0 : classes.navigationItemActive),
        parent: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.navigationItemParent)
      },
      dropdown: _stylesModule["default"].dropdown,
      dropdownContent: _stylesModule["default"]['dropdown-content']
    }, dropdownItemClasses);
  }, [dropdownItemClasses, classes]);

  var _useMemo = (0, _react.useMemo)(function () {
    var megaMenuTimeout = null;

    function cancelMegaMenuTimeout() {
      if (megaMenuTimeout) {
        window.clearTimeout(megaMenuTimeout);
        megaMenuTimeout = null;
      }
    }

    return [function () {
      cancelMegaMenuTimeout();
      megaMenuTimeout = window.setTimeout(function () {
        setShowMegaMenu(false);
        setMegaMenuChildren(null);
      }, 200);
    }, cancelMegaMenuTimeout];
  }, [setShowMegaMenu, setMegaMenuChildren]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      setMegaMenuTimeout = _useMemo2[0],
      cancelMegaMenuTimeout = _useMemo2[1];

  var onMouseEnter = (0, _react.useCallback)(function (nav) {
    var _nav$items;

    if (!megaMenu || !(nav !== null && nav !== void 0 && (_nav$items = nav.items) !== null && _nav$items !== void 0 && _nav$items.length)) {
      return;
    }

    cancelMegaMenuTimeout();
    setMegaMenuItems(nav.items);
    setMegaMenuChildren(nav.children);
    setMegaMenuProps(nav.megaMenuProps);
    setShowMegaMenu(true);
  }, [megaMenu, setMegaMenuItems, setMegaMenuChildren, setMegaMenuProps, setShowMegaMenu, cancelMegaMenuTimeout]);
  var onMouseLeave = (0, _react.useCallback)(function () {
    if (!megaMenu) {
      return;
    }

    setMegaMenuTimeout();
  }, [megaMenu, setMegaMenuTimeout]);
  var onMegaMenuMouseEnter = (0, _react.useCallback)(function () {
    if (!megaMenu) {
      return;
    }

    cancelMegaMenuTimeout();
  }, [megaMenu, cancelMegaMenuTimeout]);
  var onMegaMenuMouseLeave = (0, _react.useCallback)(function () {
    if (!megaMenu) {
      return;
    }

    setMegaMenuTimeout();
  }, [megaMenu, setMegaMenuTimeout]);
  var MegaMenuComponent = customMegaMenu !== null && customMegaMenu !== void 0 ? customMegaMenu : _Navigation["default"];
  var NavigationMobileComponent = customNavMobile !== null && customNavMobile !== void 0 ? customNavMobile : _Navigation["default"];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("header", _extends({
    ref: headerRef
  }, props, {
    className: (0, _scss.cls)(_stylesModule["default"].header, kind && _stylesModule["default"]["header--".concat(kind)], classes === null || classes === void 0 ? void 0 : classes.root, sticky && "fixed-".concat(sticky), sticky && hideOnScroll ? _stylesModule["default"]['hide-on-scroll'] : '', menuOpen && _stylesModule["default"]['header--menu-open'], forceCollapseStyle && _stylesModule["default"]['header--force-collapse-style'], megaMenu && _stylesModule["default"]['header--mega-menu'], showMegaMenu && _stylesModule["default"]['header--mega-menu--open'], showMegaMenu && (classes === null || classes === void 0 ? void 0 : classes.shownMegaMenu), 'modal-open-fix')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"].wrapper, classes === null || classes === void 0 ? void 0 : classes.wrapper)
  }, !!(logo !== null && logo !== void 0 && logo.src) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _stylesModule["default"]['logo-phantom']
  }), /*#__PURE__*/_react["default"].createElement(HeaderLogo, _extends({}, logo, {
    classes: {
      wrapper: (0, _scss.cls)('position-absolute', _stylesModule["default"].logo, classes === null || classes === void 0 ? void 0 : classes.logo, logo === null || logo === void 0 ? void 0 : (_logo$classes = logo.classes) === null || _logo$classes === void 0 ? void 0 : _logo$classes.wrapper)
    }
  }))), !!preNavContent && preNavContent, navs && navs.length > 0 || footerMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    theme: {
      collapse: (0, _scss.cls)(_stylesModule["default"].collapse, classes === null || classes === void 0 ? void 0 : classes.collapse),
      content: (0, _scss.cls)(_stylesModule["default"]['collapse-content'], classes === null || classes === void 0 ? void 0 : classes.collapseContent)
    },
    isOpened: menuOpen
  }, navs ? navs.map(function (nav, i) {
    return /*#__PURE__*/_react["default"].createElement(NavigationMobileComponent, _extends({
      key: i
    }, nav, {
      dropdownIcon: dropdownIcon,
      items: nav.items ? nav.items.map(function (item) {
        item.dropdownOpen = megaMenuChildren === item.children;
        return item;
      }) : [],
      onClick: closeOnClick ? _close : undefined,
      onWrapperMouseLeave: !isMobileMode && onMouseLeave,
      onMouseEnter: !isMobileMode && onMouseEnter,
      onMouseLeave: !isMobileMode && onMouseLeave,
      classes: getNavigationClasses(nav)
    }));
  }) : null, footerMobile && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['footer-mobile'], classes === null || classes === void 0 ? void 0 : classes.footerMobile)
  }, footerMobile)), /*#__PURE__*/_react["default"].createElement(HamburgerIcon, {
    onClick: function onClick() {
      setMenuOpen(!menuOpen);
    }
  })) : null, !!postNavContent && postNavContent), megaMenu && /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    theme: {
      collapse: (0, _scss.cls)(_stylesModule["default"]['mega-menu'], sticky && "fixed-".concat(sticky)),
      content: (0, _scss.cls)(_stylesModule["default"]['mega-menu-content'])
    },
    isOpened: showMegaMenu
  }, /*#__PURE__*/_react["default"].createElement(MegaMenuComponent, _extends({}, megaMenuProps, {
    items: megaMenuItems || [],
    onWrapperMouseEnter: !isMobileMode && onMegaMenuMouseEnter,
    onWrapperMouseLeave: !isMobileMode && onMegaMenuMouseLeave,
    classes: megaMenuClasses
  })))), !!children && (typeof children === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }) : children));
});
var _default = Header;
exports["default"] = _default;